<h2 mat-dialog-title>{{data.headline | translate}}@if (data.overall > 1) {
  ({{this.index}}/{{data.overall}})
}</h2>
<button class="close"  mat-dialog-close><i [attr.aria-label]="'arialabel.close' | translate" class="icon-x"></i></button>
<mat-dialog-content class="mat-typography">
  <div class="grid-x content-wrapper" [style.background-image]="'url(' + image + ')'">
    <div class="cell small-12 large-6">
      @if (subheadline) {
        <h3 [innerHTML]="subheadline | translate: placeholder"></h3>
      }
      @if (text) {
        <div [innerHTML]="text | translate: placeholder"></div>
      }
      @if (link && buttontext) {
        <a class="button inline-arrow-right" tabindex="0" role="button" [href]="link | translate" target="_blank" [innerHTML]="buttontext | translate: placeholder"></a>
      }
    </div>
    <div class="cell small-12 large-6">
      <span class="copyright">{{copyright | translate}}</span>
      @if (description) {
        <div class="description-wrapper" [innerHTML]="description | translate: placeholder"></div>
      }
    </div>
  </div>

  @if (data.overall > 1) {
    <button class="prev" [attr.aria-label]="'arialabel.prev.tipp' | translate" (click)="onPrev()"><i class="icon-chevron-left"></i></button>
  }
  @if (data.overall > 1) {
    <button class="next" [attr.aria-label]="'arialabel.next.tipp' | translate" (click)="onNext()"><i class="icon-chevron-right"></i></button>
  }
</mat-dialog-content>
